import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteBillPaymentRequestForm', {
    toolbarText: 'Bill Payment Details',
    mandatoryFieldsError: 'Please fill all mandatory fields.',
    saveAndSubmitRequestSuccess: 'The request is submitted for approval.',
    exchangeRateError:
        'Exchange rate is missing. Either retry loading exchange rates from NetSuite or enter manual exchange rate.',
    emptyLinesError: 'You must enter at least one line item for this transaction.',
});
